import cleanUpResponse from '@/util/cleanUpResponse';

export default async function ApproveReturnCustomerOrder(orderId, statusId, explanation, action) {
  const response = await $.soap({
    body: {
      ApproveReturnCustomerOrder: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderID: orderId,
        StatusID: statusId,
        DecisionExplanation: explanation,
        Action: action
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
